import React from "react"
import { CalendarDays, LayoutDashboard, LogOut, Settings, Trophy, UsersRound } from "lucide-react"
import { useAuth } from "./auth"
import { NavLink } from "./router"

const navItems = [
  ["/", "Overview", LayoutDashboard],
  ["/teams", "Teams", UsersRound],
  ["/games", "Games", Trophy],
  ["/settings", "Settings", Settings],
]

export function Shell({ children }) {
  const { session, logout } = useAuth()
  const initials = `${session.coach.first_name?.[0] || ""}${session.coach.last_name?.[0] || ""}`

  return (
    <div className="app-shell isolate antialiased">
      <aside className="sidebar">
        <NavLink className="brand" to="/">
          <img className="brand__mark" src="/brand/baseball-hub-logo.png" alt="" />
          <span><strong>Baseball Hub</strong><small>Team operations</small></span>
        </NavLink>
        <nav className="sidebar__nav" aria-label="Primary navigation">
          {navItems.map(([to, label, Icon]) => (
            <NavLink key={to} to={to} end={to === "/"} className={({ isActive }) => `nav-item ${isActive ? "nav-item--active" : ""}`}>
              <Icon size={19} /> <span>{label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="account-strip">
          <span className="avatar">{initials || "C"}</span>
          <span><strong>{session.coach.first_name} {session.coach.last_name}</strong><small>{session.user.email}</small></span>
          <button onClick={logout} aria-label="Sign out"><LogOut size={17} /></button>
        </div>
      </aside>
      <main className="main-content">
        <div className="mobile-topbar"><img className="brand__mark" src="/brand/baseball-hub-logo.png" alt="" /><strong>Baseball Hub</strong><CalendarDays size={19} /></div>
        {children}
      </main>
    </div>
  )
}
